<template lang="pug">
span
  v-menu(offset-y rounded="lg" max-width="400" :close-on-content-click="false" attach nudge-bottom="4" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ $t('date') }}
          .px-1.neutral400--text | 
          .text-xs.primary--text.font-medium {{ getDateText() }}
          v-icon.ml-1(size=16) $yzi-chevron-down
      //- v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
      //-   v-icon.mr-1(size=13) $yzi-plus-circle
      //-   .text-xs.text-none.font-semibold {{ $t('date') }}
    .white
      v-row(no-gutters)
        v-col
          .pa-4
            .text-sm.font-semibold {{ getDateText() }}
          v-divider.basic300
          yc-date-picker.range-date-picker(:parentDate.sync="selectedDates" range :minDate="minDate")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    dates: {
      type: Array,
      required: true,
    },
    initializeDate: {
      type: Boolean
    }
  },
  data: () => ({
    selectedDates: null,
    minDate: null,
  }),
  mounted () {
    if (this.initializeDate) {
      this.setupDates()
      this.setupMinDates()
    }
  },
  watch: {
    selectedDates (val) {
      if (!val) {
        this.$emit('update:dates', [])
        return
      }
      if (val.toString() !== this.dates.toString()) {
        let newValue = val
        if (!val[1]) {
          newValue = [val[0], val[0]]
        }
        newValue = newValue.sort()
        this.$emit('update:dates', newValue)
      }
    },
  },
  methods: {
    getDateText () {
      if (this.selectedDates && this.selectedDates.length > 0) {
        const start = this.selectedDates[0]
        let end = this.selectedDates[1]
        if (!end) {
          end = start
        }
        const dateFormat = 'd MMM yyyy'
        const startDate = DateTime.fromFormat(start, 'yyyy-MM-dd').toFormat(dateFormat)
        const endDate = DateTime.fromFormat(end, 'yyyy-MM-dd').toFormat(dateFormat)
        return `${startDate} - ${endDate}`
      }
      return '-'
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', [])
    },
    clearData () {
      this.selectedDates = null
    },
    setupMinDates () {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const min = now.minus({ days: 3 })
      this.minDate = min.toFormat(dateFormat)
    },
    setupDates () {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const start = now.minus({ days: 1 })
      this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
    },
  }
}
</script>

<style lang="scss">
.button-filter {
  min-width: 0 !important;
  color: #848484 !important;
}

.range-date-picker {

  .v-date-picker-table .v-btn.v-date-picker-table__current {
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #EEEEEE !important;
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active.v-date-picker--first-in-range, .v-btn.v-btn--active.v-date-picker--last-in-range {
    background-color: #333333 !important;
    .v-btn__content {
      color: #ffffff;
    }
  }

  .v-date-picker-table .v-btn {
    font-weight: 500;
    font-size: 16px !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black !important;
  }
}
</style>